import axios from 'axios';

import { parameters } from '../../constants/parameters';
import { Pagination } from '../../entities/pagination';
import * as genericApi from './generic-api';
import { Album, LastPhotoResponse } from '../../entities/album';

export const list = async (
  token: string,
  paramString?: object,
): Promise<{ items: Album[]; pagination: Pagination }> => {
  const url = `${parameters.api.baseUrl}/albums?with_photo=1&count[]=photos`;

  return genericApi.list<Album>(token, url, paramString);
};

export const create = async (token: string, data: Partial<Album>): Promise<Album | undefined> => {
  const url = `${parameters.api.baseUrl}/albums`;

  return genericApi.create<Album, Album>(token, url, data);
};

export const one = async (token: string, id: number): Promise<Album> => {
  const url = `${parameters.api.baseUrl}/albums/${id}`;

  return genericApi.one<Album>(token, url);
};

export const update = async (token: string, id: number, data: Partial<Album>): Promise<Album | undefined> => {
  const url = `${parameters.api.baseUrl}/albums/${id}`;

  return genericApi.update<Album, Album>(token, url, data);
};

export const deleteAlbum = async (
  token: string,
  id: number,
  deleteAll?: number,
): Promise<{
  status: string;
}> => {
  let url = `${parameters.api.baseUrl}/albums/${id}`;

  if (deleteAll) {
    url += '?with_photos=1';
  }

  try {
    const result = await axios.delete(
      url,

      { headers: { Authorization: `Bearer ${token}` } },
    );

    return result.data;
  } catch (e) {
    if (axios.isAxiosError(e)) {
      if (e.response?.data.error) {
        throw new Error(e.response?.data.error);
      }
    }

    throw e;
  }
};

export const lastPhoto = async (token: string, albumId: number): Promise<LastPhotoResponse> => {
  const url = `${parameters.api.baseUrl}/albums/${albumId}/last-photo`;

  return genericApi.one<LastPhotoResponse>(token, url);
};

const postAlbum = async (token: string, url: string, body: object): Promise<Album> => {
  try {
    const res = await axios.post(url, body, { headers: { Authorization: `Bearer ${token}` } });

    return res.data;
  } catch (e) {
    if (axios.isAxiosError(e)) {
      const data = e.response?.data;

      if (data?.errors) {
        const first = Object.values(data.errors)[0];

        throw new Error(Array.isArray(first) ? first[0] : String(first));
      }

      if (data?.error) {
        throw new Error(data.error);
      }

      if (data?.message) {
        throw new Error(data.message);
      }
    }

    throw e;
  }
};

export const createFromPhotos = async (
  token: string,
  title: string,
  photoIds: number[],
  publish?: boolean,
): Promise<Album> => {
  const url = `${parameters.api.baseUrl}/albums/from-photos`;

  return postAlbum(token, url, { title, photo_ids: photoIds, publish: !!publish });
};

export const addPhotos = async (
  token: string,
  albumId: number,
  photoIds: number[],
  publish?: boolean,
): Promise<Album> => {
  const url = `${parameters.api.baseUrl}/albums/${albumId}/photos`;

  return postAlbum(token, url, { photo_ids: photoIds, publish: !!publish });
};
